/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.modalContainer {
  margin-inline: calc(var(--spacing, 0.25rem) * 6);
  @media (width >= 40rem) {
    margin-inline: 0px;
  }
  position: relative;
  border-radius: var(--radius-sm, 0.25rem);
  --tw-shadow: 0 0 4px var(--tw-shadow-color, #0000003d);
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  background-color: var(--color-theme-surface, white);
  max-height: 90vh;
}
.modalContainer.small {
  width: 568px;
}
.modalContainer.medium {
  width: 774px;
}
.modalContainer.large {
  width: 1200px;
  @media (width >= 96rem) {
    width: 1500px;
  }
}
.modalContainer.xl {
  width: 90vw;
  height: 90vh;
}
.buttons {
  display: flex;
  position: sticky;
  background-color: var(--color-white, #fff);
  bottom: 0px;
  box-shadow: -4px 0px 0px 0px white, 4px 0px 0px 0px white;
  flex-direction: column-reverse;
  @media (width >= 40rem) {
    flex-direction: row;
  }
  gap: calc(var(--spacing, 0.25rem) * 4);
  justify-content: flex-end;
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  border-top-style: var(--tw-border-style);
  border-top-width: 1px;
  border-color: var(--color-gray-300, #d4d4d4);
  --tw-border-style: solid;
  border-style: solid;
  padding-block: calc(var(--spacing, 0.25rem) * 4);
  margin-top: calc(var(--spacing, 0.25rem) * 6);
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-border-style: solid;
    }
  }
}
